import { render, staticRenderFns } from "./ItemsPerPage.vue?vue&type=template&id=81ee1760&scoped=true&"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemsPerPage.vue?vue&type=style&index=0&id=81ee1760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ee1760",
  null
  
)

component.options.__file = "ItemsPerPage.vue"
export default component.exports